/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2025-10-11 15:26:33
 */
import '../index.scss'
import React, { useEffect, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'

import { Button, Layout, Modal, message } from 'antd'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import sensors, { sensorsRole } from '../../../utils/sensors'
import ResultCard from './ResultCard'
import success_icon from '../../../images/verify-auth/success_icon.png'
import {
  setNeedVerifyImages,
  selectVerifyResult
} from '../../../slices/verifyAuthSlice'

import PageHeader from '@/components/PageHeader'
const { Content } = Layout

// 状态统计类型
interface StatusCount {
  success: number
  fail: number
  unKnow: number
  [key: string]: number
}

export default () => {
  const navigate = useNavigate()
  const groupID = useAppSelector((state) => state.group.groupId)
  const isVip = useAppSelector((state) => state.group.isVip)
  const myRole = useAppSelector((state) => state.group.myRole)
  const dispatch = useAppDispatch()
  const verifyResult = useAppSelector(selectVerifyResult)

  const countByStatus: StatusCount = useMemo(() => {
    if (verifyResult.length) {
      return verifyResult.reduce<StatusCount>((acc, ele) => {
        acc[ele.status] = ele.list.length
        return acc
      }, { success: 0, fail: 0, unKnow: 0 })
    }
    return {
      success: 0,
      fail: 0,
      unKnow: 0
    }
  }, [verifyResult])

  const totalNum = useMemo(() => {
    return verifyResult.reduce((acc, ele) => {
      return acc + ele.list.length
    }, 0)
  }, [verifyResult])

  useEffect(() => {
    if (!verifyResult.length) {
      navigate('/verifyAuth/index')
    }
    reportSaClickEvent('enterPage')
  }, [verifyResult, dispatch])

  const reportSaClickEvent = (actionType: string, params: Record<string, any> = {}) => {
    let info = {}
    if (groupID) {
      info = {
        isGroupVIP: isVip,
        groupID: groupID,
        role: sensorsRole(myRole)
      }
    }
    sensors.track('web_click_page_verification_result', {
      actionType: actionType,
      totalNum: totalNum,
      number1: countByStatus.success,
      number2: countByStatus.fail,
      number3: countByStatus.unKnow,
      ...params,
      ...info
    })
  }

  const handleVerifyRecordClick = () => {
    reportSaClickEvent('clickVerificationRecord')
    let info = {}
    if (groupID) {
      info = {
        isGroupVIP: isVip,
        groupID: groupID,
        role: sensorsRole(myRole)
      }
    }
    Modal.confirm({
      title: '验真记录 正在开发中',
      content: '如有需要可点击下方催促开发',
      okText: '催促开发',
      onOk: () => {
        message.info('已收到反馈')
        sensors.track('web_click_page_photo_verification', {
          actionType: 'clickPopVerificatonRecordUrge',
          ...info
        })
      },
      onCancel: () =>
        sensors.track('web_click_page_photo_verification', {
          actionType: 'clickPopVerificatonRecordCancel',
          ...info
        })
    })
  }

  return (
    <Layout className="verify-auth-result">
      <PageHeader
        className="Header"
        ghost={true}
        title={
          <>
            <span
              className="verify-auth-header"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                navigate('/verifyAuth/index')
              }}
            >
              <span>照片验真</span>
            </span>

            <span
              className="title"
              style={{
                display: 'inline-block',
                margin: '0 8px',
                color: '#000'
              }}
            >
              &gt;
            </span>
            <span>
              <span>验真结果</span>
            </span>
          </>
        }
        extra={
          <>
            <Button
              style={{ cursor: 'pointer' }}
              onClick={handleVerifyRecordClick}
            >
              验真记录
            </Button>
            <Button
              style={{
                background: 'rgba(32, 122, 255, 1)',
                color: '#fff',
                cursor: 'pointer'
              }}
              onClick={() => {
                reportSaClickEvent('clickContinueVerification')
                dispatch(setNeedVerifyImages([]))
                navigate('/verifyAuth/index')
              }}
            >
              继续验真
            </Button>
          </>
        }
      />
      <Content className="content">
        <div className="result-text">
          <img src={success_icon} alt="" />
          验真完成，共上传
          <span style={{ fontWeight: 600 }}>{' ' + totalNum + ' '}</span>
          张照片
          {!!countByStatus.fail && (
            <>
              ，其中
              <span style={{ fontWeight: 600, color: 'rgba(255, 0, 0, 1)' }}>
                {' ' + countByStatus.fail + ' '}
              </span>
              张验真不通过
            </>
          )}
          {!!countByStatus.unKnow && (
            <>
              ，
              <span style={{ fontWeight: 600, color: 'rgba(255, 129, 58, 1)' }}>
                {' ' + countByStatus.unKnow + ' '}
              </span>
              张照片缺失信息无法鉴别
            </>
          )}
          {!!countByStatus.success && (
            <>
              ，
              <span style={{ fontWeight: 600, color: 'rgba(32, 183, 89, 1)' }}>
                {' ' + countByStatus.success + ' '}
              </span>
              张验真通过
            </>
          )}
        </div>
        <div className="content-container">
          {verifyResult.map((ele, index) => {
            if (ele.list.length) {
              return (
                <ResultCard
                  result={ele}
                  key={index}
                  reportSaClickEvent={reportSaClickEvent}
                />
              )
            } else {
              return null
            }
          })}
        </div>
      </Content>
    </Layout>
  )
}
